import * as insights from '@ably/ui/core/insights';

// Expose this module as a global variable
window.AblyInsights = insights;
